































































import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";

import DoKoHtmlDialog from "./DoKoHtmlDialog.vue";
import DoKoBtn from "../controls/DoKoBtn.vue";
import { api as deskApi } from "../../store/modules/desk";
import { GameModeInfos } from "../../store/modules/desk/types";
import { Dictionary } from "lodash";
import { GameMode, Restriction, FriendRef, ANON_CARDS } from "@dokogd/shared";

@Component({ components: { DoKoHtmlDialog, DoKoBtn } })
export default class DoKoDialogGameMode extends Vue {
  @Getter(deskApi.getters.getGameModeInfo, { namespace: deskApi.namespace })
  gameModeInfo!: GameModeInfos;

  @Getter(deskApi.getters.getMappedUsers, { namespace: deskApi.namespace })
  mappedUsers!: Dictionary<FriendRef>;

  @Mutation(deskApi.mutations.TOGGLE_DISPLAY_GAME_MODE, {
    namespace: deskApi.namespace,
  })
  toggleDisplayMode!: () => void;

  get title(): string {
    if (typeof this.restriction === "string") {
      const textMap = {
        solo: "Fleischlos",
        "solo-Q": "Damen-Solo",
        "solo-J": "Buben-Solo",
        "solo-♣": "Farbensolo (Kreuz)",
        "solo-♠": "Farbensolo (Pik)",
        "solo-♥": "Farbensolo (Herz)",
        "solo-♦": "Farbensolo (Karo)",
        "wedding-trump": "Hochzeit",
        "wedding-non-trump": "Hochzeit",
      };
      return textMap[this.restriction] ?? "";
    } else if (this.restriction === false) {
      return "Standardspiel";
    } else {
      const suffix = this.restriction.cards.length === 4 ? " mit Fuchs" : "";
      return "Armut" + suffix;
    }
  }

  get playerId() {
    return this.gameModeInfo?.restriction?.playerId ?? "";
  }

  get avatarId() {
    return this.mappedUsers[this.playerId]?.avatarId ?? "000";
  }
  get playerName() {
    return this.mappedUsers[this.playerId]?.displayName ?? "Unbekannt";
  }

  get wealthyPlayerId() {
    if (this.restriction instanceof Object) {
      const type = this.restriction;
      return type.wealthyPlayer ?? "";
    } else {
      return "";
    }
  }
  get wealthyAvatarId() {
    console.log("this.mappedUsers[", this.mappedUsers, this.wealthyPlayerId);
    return this.mappedUsers[this.wealthyPlayerId]?.avatarId ?? "000";
  }
  get wealthyPlayerName() {
    return this.mappedUsers[this.wealthyPlayerId]?.displayName ?? "Unbekannt";
  }

  get modusName() {
    if (typeof this.restriction === "string") {
      const textMap = {
        solo: "einen Fleischlosen. Es gibt kein Trumpf.",
        "solo-Q": "ein Damen-Solo. Nur die Damen sind Trumpf",
        "solo-J": "ein Buben-Solo. Nur die Buben sind Trumpf",
        "solo-♣":
          "ein Farbensolo ♣. ♦ Ass, 10 und König werden gegen ♣ Ass, 10 und König ausgetauscht.",
        "solo-♠":
          "ein Farbensolo ♠. ♦ Ass, 10 und König werden gegen ♠ Ass, 10 und König ausgetauscht.",
        "solo-♥":
          "ein Farbensolo ♥. ♦ Ass, 10 und König werden zu Fehl. ♥ Ass und König werden zu Trumpf.",
        "solo-♦":
          "ein Farbensolo ♦. Das Deck entspricht der normalen Sortierung.",
        "wedding-trump": "eine Hochzeit (Erster Trumpf in fremde Hand)",
        "wedding-non-trump": "eine Hochzeit (Erster fremder Fehl)",
      };
      return textMap[this.restriction] ?? "";
    } else if (this.restriction === false) {
      return "Standardspiel";
    } else {
      const suffix = this.restriction.cards.length === 4 ? " mit Fuchs" : "";
      return "eine Armut" + suffix;
    }
  }

  get type() {
    if (typeof this.restriction === "string") {
      return "simple";
    } else if (this.restriction === false) {
      return "default";
    } else {
      return "poverty";
    }
  }

  get tumpCount() {
    const r = this.restriction;
    if (r instanceof Object) {
      return r.cardsReturned.filter(v => v.startsWith("trump")).length;
    } else {
      return 0;
    }
  }

  get restriction(): Restriction<ANON_CARDS[]> {
    return this.gameModeInfo?.restriction?.type ?? false;
  }

  get symbolName() {
    const restriction = this.restriction;
    if (restriction === false) {
      return "standard";
    } else if (typeof restriction === "string") {
      return restriction.startsWith("wedding-") ? "wedding" : restriction;
    } else {
      const suffix = restriction.cards.length === 4 ? "-fox" : "";
      return restriction.type + suffix;
    }
  }

  mounted() {
    console.log(this.gameModeInfo);
  }
}
